import ResendWelcomeEmailPage from "./ResendWelcomeEmailPage";

export default ResendWelcomeEmailPage;
